<template>
  <div class="applicationSection containerDiv mt-2 mb-3">
    <h5 class="application-label ContentSection line-hight0">
      Contact Roles
      <span class="margin-left-right-5px">|</span>
      <span
        class="application-accountBu-text"
      >{{accessibleAccount.cadebillAccountNo }} {{accessibleAccount.accountName}}</span>
      <!-- <font-awesome-icon :icon="applicationexpandStateIcon" class="float-right margin-point-4rem" /> -->
    </h5>
    <b-collapse id="contactrole-list" visible>
      <b-card>
        <b-table
          :sticky-header="height"
          :busy.sync="isBusy"
          striped
          :items="selectedContactRoles"
          :fields="columnsfield"
          :show-empty="showempty"
          no-border-collapse
          head-variant="head-border"
        >
          <template v-slot:table-busy>
            <div class="text-center">
              <b-spinner class="align-middle gridSpinner"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(roles)="data">
              <span :title="data.value">{{data.value.replace(/;/g, ", ")}}</span>
          </template>
          <template v-slot:cell(edit)>
            <span>
              <a class="link" @click="setRole()">Edit</a>
            </span>
          </template>
        </b-table>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import { eventbus } from "../../main";
export default {
  name: "ContactRole",
  data() {
    return {
      isBusy: true,
      showempty: true,
      height: "",
      contactRoles: [{ roles: "", edit: "" }]
    };
  },
  props: {
    accessibleAccount: Object,
    applicationName: String,
    role: String
  },
  computed: {
    columnsfield: function() {
      var fields = [
        {
          key: "roles",
          label: "Role Name",
          tdClass: ["th-td-width", "cell-ellipsis", "contactRole-tdClass"],
          thClass: ["th-td-width", "contactRole-thClass"]
        },
        {
          key: "edit",
          label: "Edit",
          tdClass: ["th-td-min-width", "cell-ellipsis", "contactRole-tdClass"],
          thClass: ["th-td-min-width", "contactRole-thClass"]
        }
      ];
      return fields;
    },
    selectedContactRoles: function() {
      return this.GetRoles();
    }
  },
  methods: {
    setRole: function() {
      eventbus.$emit("setApplicationSetting", this.applicationName);
    },
    GetRoles:function(){
      this.isBusy = false;
      this.contactRoles[0].roles = this.role;
      this.contactRoles[0].edit = "Edit";
      return this.contactRoles
    }
  }
};
</script>